import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.tsx'

// Initialize theme before React renders to prevent flash
const initTheme = () => {
  const storedTheme = localStorage.getItem('jp-theme')
  if (storedTheme) {
    try {
      const { state } = JSON.parse(storedTheme)
      const theme = state?.theme || 'system'
      const root = document.documentElement
      
      root.classList.remove('light', 'dark')
      
      if (theme === 'system') {
        const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
        root.classList.add(systemTheme)
      } else if (theme === 'light' || theme === 'dark') {
        root.classList.add(theme)
      }
    } catch (e) {
      // Default to light if there's an error
      document.documentElement.classList.add('light')
    }
  } else {
    // Default to system preference
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    document.documentElement.classList.add(systemTheme)
  }
}

// Apply theme immediately
initTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
